import "./tab0.scss";
import DotIndicator from "../../../../../ui/dotindicator/dotindicator";
import HorizontalDivider from "../../../../../ui/horizontaldivider/horizontaldivider";
import SingleSelectDropzone from "../../../../../ui/dropzone/singleselect/singleSelectDropzone";
import Matchingadtemplate from "../../../../../ui/adtemplate/matchingadtemplate/matchingadtemplate";
import {DropDownItem} from "../../../../../modals/types/dropdown";
import DropDown from "../../../../../ui/dropdown/dropdown";

const Tab0 = () => {
    const colorDropDownItems: DropDownItem[] = [
        {label: "قرمز"}, {label: "زرد"}, {label: "سبز"}, {label: "آبی"}
    ];
    return (
        <div className="Tab0">
            <div className="row">
                <div className="d-flex align-items-center mb-4">
                    <DotIndicator/>
                    <span>تنظیمات کلی</span>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <label htmlFor="campaignName">عنوان کمپین</label>
                    <input type="text" name="campaignName" id="campaignName" className="Campaign-Input mt-2"
                           placeholder="مثال: کمپین روز مادر"/>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <label htmlFor="URL">آدرس صفحه فرود تبلیغ شما</label>
                    <input type="text" name="URL" id="URL" className="Campaign-Input mt-2" placeholder="URL"/>
                </div>
            </div>
            <HorizontalDivider/>
            <div className="row pt-2">
                <div className="d-flex align-items-center mb-4">
                    <DotIndicator/>
                    <span>تنظیمات تبلیغ</span>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <label htmlFor="Ad-Title">عنوان تبلیغ</label>
                    <input type="text" name="Ad-Title" id="Ad-Title" className="Campaign-Input mt-2"
                           placeholder="مثال: کمپین روز مادر"/>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <label className={"mb-2"} htmlFor="">رنگ برند</label>
                    <DropDown items={colorDropDownItems} placeHolder={"قرمز"}/>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <label htmlFor="Btn-Title">عنوان دکمه</label>
                    <input type="text" name="Btn-Title" id="Btn-Title" className="Campaign-Input mt-2"
                           placeholder="مثال: تخفیف ۲۰ درصدی روز مادر"/>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <label className={"mb-2"} htmlFor="">رنگ دکمه</label>
                    <DropDown items={colorDropDownItems} placeHolder={"سیاه"}/>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mt-3 mb-3">
                    <SingleSelectDropzone title={"آپلود تصویر"}/>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mt-3 mb-3">
                    <Matchingadtemplate type={0}/>
                </div>
            </div>
        </div>
    );
}

export default Tab0;